import {
  SpoilerProps as MantineSpoilerProps,
  Spoiler as MantineSpoiler,
} from '@mantine/core';

export type SpoilerProps = MantineSpoilerProps;

export const Spoiler = MantineSpoiler;

Spoiler.displayName = 'Spoiler';
